import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NextPageRoute } from "@cvx/nextpage/public_api";
import { HomeComponent } from "./home/home.component";
import { ContactComponent } from "./help/contact/contact.component";
import { HelpComponent } from "./help/help/help.component";
import { AdministrationComponent } from "./administration/administration.component";
import { UsersAndRolesComponent } from "./administration/users-roles/users-roles.component";
import { CustomErrorComponent } from "./shared/error-page/custom-error-page.component";
import { EditUserComponent } from "./administration/users-roles/edit-user/edit-user.component";

import { RoleGuard } from "./role-guard";
import { PageConfig } from "./page-config";
import { RoutesService } from "./services/routes.service";
import { NoAccessComponent } from "./shared/no-access/no-access.component";
import { CalGuardService } from "@cvx/cal-angular";
import { ERTUserComponent } from "./ert-user/ert-user.component";
import { ERTEducationComponent } from "./ert-education/ert-education.component";
import { PickListsComponent } from "./administration/picklists/picklists.component";
import { ERTEducationFormComponent } from "./ert-education/ert-education-form/ert-education-form.component";
import { ErtEducationViewComponent } from "./ert-education/ert-education-view/ert-education-view.component";
import { QualifiedListComponent } from "./ert-education/qualified-list/qualified-list.component";
import { SelectUserComponent } from "./ert-education/select-user/select-user.component";
import { ErtEmergencyResponseAdditionalinfoComponent } from "./ert-emergency-response/ert-emergency-response-additionalinfo/ert-emergency-response-additionalinfo.component";
import { ERTEmergencyResponseDetailsComponent } from "./ert-emergency-response/ert-emergency-response-details/ert-emergency-response-details.component";
import { ERTEmergencyResponseComponent } from "./ert-emergency-response/ert-emergency-response.component";
import { ErtFiredepartmentBcTurnoverComponent } from "./ert-firedepartment-bc-turnover/ert-firedepartment-bc-turnover.component";
import { ErtKr998ViewComponent } from "./ert-kr998/ert-kr998-view/ert-kr998-view.component";
import { ERTKr998Component } from "./ert-kr998/ert-kr998.component";
import { ErtNewKr998Component } from "./ert-kr998/ert-new-kr998/ert-new-kr998.component";
import { ErtPreplanRescueComponent } from "./ert-preplan-rescue/ert-preplan-rescue.component";
import { NewErtPreplanRescueComponent } from "./ert-preplan-rescue/new-ert-preplan-rescue/new-ert-preplan-rescue.component";
import { ErtUserViewComponent } from "./ert-user/ert-user-view/ert-user-view.component";
import { ErtNewUserDetailsComponent } from "./ert-user/new-user/ert-new-user-details/ert-new-user-details.component";
import { ErtNewUserComponent } from "./ert-user/new-user/ert-new-user/ert-new-user.component";
import { ERTFiredepartmentBcTurnoverCreateComponent } from "./ert-firedepartment-bc-turnover/ert-firedepartment-bc-turnover-create.component";
import { ERTFiredepartmentBcTurnoverEditComponent } from "./ert-firedepartment-bc-turnover/ert-firedepartment-bc-turnover-edit.component";
import { ErtEditKr998Component } from "./ert-kr998/ert-edit-kr998/ert-edit-kr998.component";
import { EditErtPreplanRescueComponent } from "./ert-preplan-rescue/edit-ert-preplan-rescue/edit-ert-preplan-rescue.component";
import { ErtKr998ErtUsersEditComponent } from "./ert-kr998/ert-kr998-view/ert-kr998-ert-users-edit/ert-kr998-ert-users-edit.component";
import { ErtKr998ertusersDetailsComponent } from "./ert-kr998/ert-kr998-view/ert-kr998-ertusers-details/ert-kr998-ertusers-details.component";
import { ErtKr998UpdateAttendanceComponent } from "./ert-kr998/ert-kr998-view/ert-kr998-update-attendance/ert-kr998-update-attendance.component";
import { ErtAddAdditionalUserComponent } from "./ert-kr998/ert-kr998-view/ert-add-additional-user/ert-add-additional-user.component";
import { NewKr998AddCrewComponent } from "./ert-kr998/ert-new-kr998/new-kr998-add-crew/new-kr998-add-crew.component";
import { ErtEmergencyResponseViewComponent } from "./ert-emergency-response/ert-emergency-response-view/ert-emergency-response-view.component";
import { ErtEmergencyResponseAddmrsCreateComponent } from "./ert-emergency-response/ert-emergency-response-addmrs/ert-emergency-response-addmrs-create/ert-emergency-response-addmrs-create.component";
import { ErtEmergencyResponseAddmrsAdditionalInfoComponent } from "./ert-emergency-response/ert-emergency-response-addmrs/ert-emergency-response-addmrs-additional-info/ert-emergency-response-addmrs-additional-info.component";
import { ErtEmergencyResponseAddmrsPatientVitalsComponent } from "./ert-emergency-response/ert-emergency-response-addmrs/ert-emergency-response-addmrs-patient-vitals/ert-emergency-response-addmrs-patient-vitals.component";
import { MedicalRunsheetViewComponent } from "./ert-emergency-response/medical-runsheet-view/medical-runsheet-view.component";
import { FacilitiesComponent } from "./administration/facilites/facilities.component";
import { EditFacilityComponent } from "./administration/facilites/edit-facility.component";

let routes: NextPageRoute[] = [
  {
    path: "home",
    title: "Home",
    redirectTo: "/",
    pathMatch: "full",
  },
  {
    path: "ert-user",
    title: "User",
    children: [
      {
        path: "",
        title: "User",
        component: ERTUserComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "ert-new-user",
        component: ErtNewUserComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "ert-new-user-details",
        component: ErtNewUserDetailsComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "ert-user-view",
        component: ErtUserViewComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
    ],
  },
  {
    path: "ert-education",
    title: "Education",
    children: [
      {
        path: "",
        title: "Education",
        component: ERTEducationComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "new-entry",
        component: ERTEducationFormComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "select-user",
        component: SelectUserComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "qualified-list",
        component: QualifiedListComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "ert-education-view",
        component: ErtEducationViewComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
    ],
  },
  {
    path: "ert-kr998",
    title: "KR-998",
    children: [
      {
        path: "",
        title: "KR-998",
        component: ERTKr998Component,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "ert-new-kr998",
        component: ErtNewKr998Component,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "ert-new-kr998-add-crew/:id",
        component: NewKr998AddCrewComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "ert-kr998-view/:id",
        component: ErtKr998ViewComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "ert-kr998-additional-user/:id",
        component: ErtAddAdditionalUserComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "ert-kr998-update-attendance/:id",
        component: ErtKr998UpdateAttendanceComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "ert-edit-kr998/:id",
        component: ErtEditKr998Component,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "ert-edit-kr998ErtUsersDetailsView/:id",
        component: ErtKr998ErtUsersEditComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "ert-edit-kr998ErtUsersDetailsId/:id",
        component: ErtKr998ertusersDetailsComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
    ],
  },
  {
    path: "ert-emergency-response",
    title: "Emergency Response",
    children: [
      {
        path: "",
        title: "Emergency Response",
        component: ERTEmergencyResponseComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "emergency-details",
        component: ERTEmergencyResponseDetailsComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "emergency-additional-info",
        component: ErtEmergencyResponseAdditionalinfoComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "emergency-response-view",
        component: ErtEmergencyResponseViewComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "emergency-response-addmrs-create",
        component: ErtEmergencyResponseAddmrsCreateComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "emergency-response-addmrs-additional-info",
        component: ErtEmergencyResponseAddmrsAdditionalInfoComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "emergency-response-addmrs-patient-vitals",
        component: ErtEmergencyResponseAddmrsPatientVitalsComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "medical-runsheet-view",
        component: MedicalRunsheetViewComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
    ],
  },
  {
    path: "preplan-rescue",
    title: "Preplan Rescue",
    children: [
      {
        path: "",
        component: ErtPreplanRescueComponent,
        canActivate: [CalGuardService],
      },
      {
        path: "create",
        component: NewErtPreplanRescueComponent,
        canActivate: [CalGuardService],
      },
      {
        path: "edit/:id",
        component: EditErtPreplanRescueComponent,
        canActivate: [CalGuardService],
      },
    ],
  },
  {
    path: "firedepartment-bc-turnover",
    title: "Fire Department BC Turnover",
    children: [
      {
        path: "",
        component: ErtFiredepartmentBcTurnoverComponent,
        canActivate: [CalGuardService],
        data: PageConfig.UserReadOnly,
      },
      {
        path: "create",
        component: ERTFiredepartmentBcTurnoverCreateComponent,
        canActivate: [CalGuardService],
      },
      {
        path: "edit/:id",
        component: ERTFiredepartmentBcTurnoverEditComponent,
        canActivate: [CalGuardService],
      },
    ],
  },
  {
    path: "administration",
    title: "Administration",
    data: PageConfig.AdministratorOnly,
    children: [
      {
        path: "",
        redirectTo: "pick-lists",
        pathMatch: "full",
        data: PageConfig.AdministratorOnly,
      },
      {
        path: "pick-lists",
        title: "Pick Lists",
        children: [
          {
            path: "",
            component: PickListsComponent,
            canActivate: [CalGuardService],
            data: PageConfig.AdministratorOnly,
          },
        ],
      },
      {
        path: "user-roles",
        title: "User and Roles",
        children: [
          {
            path: "",
            component: UsersAndRolesComponent,
            canActivate: [CalGuardService, RoleGuard],
            data: PageConfig.AdministratorOnly,
          },
          {
            path: "edit-user",
            component: EditUserComponent,
            canActivate: [CalGuardService, RoleGuard],
            data: PageConfig.AdministratorOnly,
          },
        ],
      },
      {
        path: "facilities",
        title: "Facilities",
        children: [
          {
            path: "",
            component: FacilitiesComponent,
            canActivate: [CalGuardService, RoleGuard],
            data: PageConfig.AdministratorOnly,
          },
          {
            path: "edit/:id",
            component: EditFacilityComponent,
            canActivate: [CalGuardService, RoleGuard],
            data: PageConfig.AdministratorOnly,
          },
        ],
      },
    ],
  },
  {
    path: "help",
    title: "Help",
    canActivate: [CalGuardService],
    children: [
      {
        path: "",
        title: "Help",
        redirectTo: "main",
        pathMatch: "full",
      },
      {
        path: "main",
        title: "Help",
        component: HelpComponent,
        canActivate: [CalGuardService],
      },
      {
        path: "contact-us",
        title: "Contact",
        component: ContactComponent,
        canActivate: [CalGuardService],
      },
    ],
  },
  {
    path: "",
    title: "Main",
    children: [
      {
        path: "",
        component: HomeComponent,
        canActivate: [CalGuardService],
      },
    ],
  },
  { path: "error", component: CustomErrorComponent },
  { path: "no-access", component: NoAccessComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private routesService: RoutesService) {
    this.routesService.filterRoutesForMenu(routes);
  }
}
